// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-responsive {
  position: relative;
  overflow: hidden;
  flex: 1 0 auto;
  display: flex;
}
.v-responsive__content {
  flex: 1 0 0px;
}
.v-responsive__sizer {
  transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
  flex: 0 0 0px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/src/stylus/components/_responsive.styl"],"names":[],"mappings":"AAEA;EACE,kBAAU;EACV,gBAAU;EACV,cAAM;EACN,aAAS;AADX;AAGE;EACE,aAAM;AADV;AAGE;EACE,+DAAY;EACZ,aAAM;AADV","sourcesContent":["@import '../bootstrap'\n\n.v-responsive\n  position: relative\n  overflow: hidden\n  flex: 1 0 auto\n  display: flex\n\n  &__content\n    flex: 1 0 0px\n\n  &__sizer\n    transition: padding-bottom 0.2s $transition.swing\n    flex: 0 0 0px\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
